<template>
  <input :id="getId" type="radio" :value="label" :name="name" v-model="radioButtonValue" class="btn-check"
    autocomplete="off" :disabled="disableRadio" />
  <label class="btn btn-outline-secondary form-control" :for="getId">
    {{ label }}
  </label>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "RadioButton",
  emits: ["change"],
  props: {
    name: { type: String, required: true },
    label: { type: String, required: true },
    value: { type: String, required: true }
  },
  data() {
    return {
      disableRadio: false
    };
  },
  computed: {
    getId() {
      const id = this.label.replace(/\s/g, "");
      return id + this.name + "Id";
    },
    radioButtonValue: {
      get: function () {
        return this.value;
      },
      set: function () {
        this.$emit("change", this.label);
      }
    }
  },
  methods: {
    setDisabledState(disabled: boolean) {
      this.disableRadio = disabled;
    }
  }
});
</script>

<style scoped>
@media (max-width: 576px) {
  .btn {
    padding-left: 0.52rem;
    padding-right: 0.52rem;
  }
}
</style>